import { render, staticRenderFns } from "./AAsignacionProgV2.vue?vue&type=template&id=255ee398&scoped=true"
import script from "./AAsignacionProgV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionProgV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionProgV2.vue?vue&type=style&index=0&id=255ee398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ee398",
  null
  
)

export default component.exports